import React, { useEffect, useState } from 'react';
import { Layout, Grid } from 'antd';

interface SiderProps {
	children: JSX.Element | JSX.Element[];
}

const { useBreakpoint } = Grid;

export function Sider({ children }: Readonly<SiderProps>): JSX.Element {
	const breakpoints = useBreakpoint();
	const [isCollapsed, setIsCollapsed] = useState<boolean>(false);

	const isExtraLargeScreen = breakpoints.xl ?? true;

	function handleOnCollapse(): void {
		setIsCollapsed((prevState) => !prevState);
	}

	useEffect(() => {
		setIsCollapsed(!isExtraLargeScreen);
	}, [isExtraLargeScreen]);

	return (
		<Layout.Sider
			id="sider"
			width={250}
			collapsible
			theme="light"
			collapsed={isCollapsed}
			onCollapse={handleOnCollapse}
		>
			{children}
		</Layout.Sider>
	);
}
